import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import aboutImage from './aboutImage.jpg';
import beforeAfterImage from '../B&A/BA2.jpg';
import { popularServices } from '../../data/servicesData';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';


// Import new images
import serviceImage1 from './laser-hair-removal.jpeg';
import serviceImage2 from './micro-needling.jpg';
import serviceImage3 from './cryo-t-shock.jpg';
import serviceImage4 from './HeroOCEAN.jpeg';
import serviceImage5 from './image00003.jpeg';
import serviceImage6 from './image00004.jpeg';

const Home = () => {
  const navigate = useNavigate();
  const [selectedService, setSelectedService] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleServiceClick = (serviceId, category) => {
    setSelectedService(serviceId);
    setIsLoading(true);
    
    // Add a small delay for visual feedback
    setTimeout(() => {
      navigate('/services', { 
        state: { 
          selectedService: serviceId,
          selectedCategory: category 
        } 
      });
    }, 300);
  };

  // Enhanced services with new images
  const services = [
    { 
      id: 'laser-hair-removal',
      name: 'Laser Hair Removal', 
      image: serviceImage1, 
      category: 'Laser Hair Removal',
      description: 'Professional laser hair removal for long-lasting results',
      icon: null
    },
    { 
      id: 'microneedling',
      name: 'Microneedling', 
      image: serviceImage2, 
      category: 'Body Contouring',
      description: 'Treatment to improve skin texture and appearance',
      icon: null
    },
    { 
      id: 'cryo-cavitation',
      name: 'Cryo T-Shock', 
      image: serviceImage3, 
      category: 'Body Contouring',
      description: 'Non-invasive body contouring treatment option',
      icon: null
    },
  ];

  return (
    <div className="relative">
      {/* Ocean Wave Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-1/2 -left-1/4 w-[150%] h-[150%] bg-gradient-to-br from-blue-50/50 via-cyan-50/30 to-transparent rounded-full blur-3xl animate-float"></div>
        <div className="absolute -bottom-1/2 -right-1/4 w-[150%] h-[150%] bg-gradient-to-tl from-cyan-50/50 via-blue-50/30 to-transparent rounded-full blur-3xl animate-float" style={{animationDelay: '3s'}}></div>
      </div>

      <div className="container mx-auto px-4 py-8 relative z-10">
        {/* About Section with Ocean Theme */}
        <div className="relative mb-12">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-50/80 to-cyan-50/80 rounded-3xl transform -skew-y-2 blur-sm"></div>
          <Card className="relative overflow-hidden border-0 bg-white/90 backdrop-blur-md shadow-2xl">
            <CardContent className="p-0">
              <div className="flex flex-col lg:flex-row gap-8 p-8 lg:p-12">
                <div className="lg:w-2/3 space-y-6">
                  <div className="inline-flex items-center gap-2 text-blue-600 font-medium">
                    <span className="text-sm uppercase tracking-wider">Welcome to Oceanique</span>
                  </div>
                  <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold">
                    <span className="bg-gradient-to-r from-blue-600 via-cyan-600 to-blue-600 bg-clip-text text-transparent bg-size-200 animate-gradient">
                      About Oceanique
                    </span>
                  </h2>
                  <p className="text-lg lg:text-xl text-gray-700 leading-relaxed">
                    At Oceanique Medical Spa, we offer a range of medical aesthetic treatments in a comfortable setting. 
                    Our team uses modern technology and techniques to help you achieve your aesthetic goals through 
                    personalized treatment plans. We specialize in laser treatments, body contouring, and skin rejuvenation 
                    services tailored to your individual needs.
                  </p>
                  <div className="flex items-center gap-4">
                    <Link 
                      to="/about" 
                      className="group inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-6 py-3 rounded-full font-medium hover:shadow-lg transition-all duration-300 hover:scale-105"
                    >
                      Learn More About Us

                    </Link>
                  </div>
                </div>
                <div className="lg:w-1/3">
                  <div className="relative group">
                    <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-cyan-400 rounded-2xl blur-2xl opacity-60 group-hover:opacity-80 transition-opacity duration-500"></div>
                    <img 
                      src={serviceImage4} 
                      alt="About us" 
                      className="relative rounded-2xl shadow-xl w-full h-80 object-cover transform transition-transform duration-700 group-hover:scale-[1.02]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent rounded-2xl"></div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Popular Services Section */}
        <div className="relative py-12 -mx-4 px-4 mb-12">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-100/50 via-cyan-100/50 to-blue-100/50 blur-3xl"></div>
          <div className="relative">
            <div className="text-center mb-8 space-y-3">
              <div className="inline-flex items-center gap-2 text-blue-600 font-medium">
                <span className="text-sm uppercase tracking-wider">Our Specialties</span>
              </div>
              <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold">
                <span className="bg-gradient-to-r from-blue-600 via-cyan-600 to-blue-600 bg-clip-text text-transparent bg-size-200 animate-gradient">
                  Most Popular Services
                </span>
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Explore our most requested treatment options
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {services.map((service) => (
                <Card
                  key={service.id}
                  onClick={() => handleServiceClick(service.id, service.category)}
                  className={`
                    group relative overflow-hidden cursor-pointer
                    transform transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl
                    ${selectedService === service.id ? 'ring-4 ring-blue-400 ring-offset-2 scale-[1.02]' : ''}
                    ${isLoading && selectedService === service.id ? 'animate-pulse' : ''}
                    border-0 bg-white/90 backdrop-blur-sm
                  `}
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-600/5 to-cyan-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  
                  <div className="relative h-64 overflow-hidden">
                    <img 
                      src={service.image} 
                      alt={service.name} 
                      className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110" 
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-blue-900/90 via-blue-900/50 to-transparent"></div>
                  </div>
                  
                  <CardContent className="relative p-6 space-y-3">
                    <h3 className="text-2xl font-bold text-gray-800 group-hover:text-blue-600 transition-colors">
                      {service.name}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {service.description}
                    </p>
                    <div className="flex items-center justify-between pt-2">
                      <span className="text-sm text-blue-600 font-medium">
                        {service.category}
                      </span>

                    </div>
                  </CardContent>
                  
                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-cyan-600/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
                </Card>
              ))}
            </div>
            
            <div className="text-center mt-12">
              <Link 
                to="/services" 
                className="group inline-flex items-center gap-2 bg-white text-blue-600 border-2 border-blue-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-blue-600 hover:text-white transition-all duration-300 hover:scale-105 hover:shadow-lg"
              >
                View All Services

              </Link>
            </div>
          </div>
        </div>

        {/* Before & After Section */}
        <div className="relative py-12 -mx-4 px-4">
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-50/80 to-blue-50/80 rounded-3xl blur-3xl"></div>
          <Card className="relative overflow-hidden border-0 bg-white/90 backdrop-blur-md shadow-2xl">
            <CardContent className="p-8 lg:p-12">
              <div className="text-center mb-8 space-y-3">
                <div className="inline-flex items-center gap-2 text-blue-600 font-medium">
                  <span className="text-sm uppercase tracking-wider">Transformations</span>
                </div>
                <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold">
                  <span className="bg-gradient-to-r from-blue-600 via-cyan-600 to-blue-600 bg-clip-text text-transparent bg-size-200 animate-gradient">
                    See Our Results
                  </span>
                </h2>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                  View actual treatment results
                </p>
              </div>
              
              <div className="max-w-4xl mx-auto">
                <div className="relative group">
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-cyan-400 rounded-2xl blur-2xl opacity-40 group-hover:opacity-60 transition-opacity duration-500"></div>
                  <img 
                    src={beforeAfterImage} 
                    alt="Before and After" 
                    className="relative w-full h-auto max-h-[600px] object-contain rounded-2xl shadow-xl transform transition-transform duration-700 group-hover:scale-[1.02]" 
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent rounded-2xl"></div>
                </div>
                
                <div className="text-center mt-8 space-y-4">
                  <p className="text-lg text-gray-700">
                    Discover the amazing transformations our clients have experienced with our advanced treatments.
                  </p>
                  <Link 
                    to="/before-after" 
                    className="group inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-8 py-4 rounded-full font-semibold text-lg hover:shadow-lg transition-all duration-300 hover:scale-105"
                  >
                    View Before & After Gallery

                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        
      </div>
    </div>
  );
};

export default Home;
